export default {
	queryCondition: 'Query conditions',
	applyNo: 'Business order number',
	pleaseEnter: 'Please Enter',
	messageType: 'Message Type',
	pleaseSelect: 'Please Select',
	messageTypeProduction: 'Production',
	messageTypeConsumption: 'Consumption',
	selectDate: 'Please select a date',
	createDate: 'Creation Date',
	queryResult: 'Search Result',
	createTime: 'Creation time',
	parameters: 'Parameters',
	retryNum: 'Number of retries',
	errorMessage: 'Error message',
	operate: 'Operation',
	edit: 'Edit',
	retry: 'Retry',
	pleaseEnterContent: 'Please enter content',
	confirm: 'Confirm',
	cancel: 'Cancel',
	saveSuccess: 'Saved successfully',
	operateSuccessfully: 'Operation successful',
	fundingRequestList: 'My Funding Request List'
};
